import { Box, Typography, Grid } from "@mui/material";
import contactimg from "../../images/disclaim.jpg";
import NavBar from "../../NavBar/NavBar";
import { useEffect, useRef, useState } from "react";
import SEO from "../../app/SEO";

export default function Disclaimer() {
  const [lightNav, setLightNav] = useState(true);
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setLightNav(entry.isIntersecting);
      },
      { threshold: 0.05 }
    );

    if (heroRef.current) observer.observe(heroRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F6F5F3", minHeight: "100vh" }}>
      <SEO
        title="Privacy Policy| Talent Representation, Bookings & Fan Experiences"
        description=""
        canonical={``}
        ogImage={""}
      />
      <NavBar mode={lightNav ? "light" : "dark"} />
      {/* HERO */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "45vh", md: "60vh" },
          backgroundColor: "#0B0B0B",
          overflow: "hidden",
        }}
      >
        <Box
          ref={heroRef}
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${contactimg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.6)",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            bottom: { xs: 40, md: 80 },
            left: { xs: 24, md: 80 },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Playfair Display",
              fontSize: { xs: "2.5rem", md: "4.5rem" },
              color: "#FFFFFF",
              fontWeight: 700,
              letterSpacing: "0.05em",
              textTransform: "uppercase",
            }}
          >
            Privacy Policy
          </Typography>
        </Box>
      </Box>

      {/* CONTENT */}
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 3, md: 8 },
          py: { xs: 8, md: 12 },
        }}
      >
        <Grid item xs={12} md={4}>
          <Typography sx={bodyStyle}>
            Effective February 27, 2023 Notice Version 1.0 Data Controller
            Contact Information: Helvieta, LLC. 9336 Civic Center Dr, Beverly
            Hills, CA 90210 1-(877) 678-1770 privacy@helvieta.com Our privacy
            notice governs our privacy practices when visiting
            https://www.helvieta. com (“Website”). Our privacy notice tells you
            what personal and non-Personal Information we collect from you, how
            we collect them, how we protect them, how we disclose them, how you
            can access and change them, and how you can limit our disclosing of
            them. Our privacy notice also explains certain legal rights that you
            have about your data. This policy applies to information we collect:
            <br />
            <br /> <br />• On this Website. <br />
            <br /> <br />• In email, text, and other electronic messages between
            you and this Website. <br />
            <br /> <br />• When you interact with our advertising and
            applications on third-party websites and services if those
            applications or advertising include links to this policy. It does
            not apply to information collected by: <br />
            <br /> <br />• Us offline or through any other means, including on
            any other website operated by Company or any third party (including
            our affiliates and subsidiaries); or <br />
            <br /> <br />• Any third party (including our affiliates and
            subsidiaries), including through any application or content
            (including advertising) that may link to or be accessible from or on
            the Website. Any capitalized terms not defined herein will have the
            same meaning as those defined elsewhere on our website. Definitions
            ‘NON-PERSONAL INFORMATION’ (NPI) means any information that is in no
            way personally identifiable. ‘PERSONAL INFORMATION’ (PI) means any
            information relating to an identified or identifiable natural person
            (‘data subject’); an identifiable natural person can be identified
            directly or indirectly by reference to an identifier such as a name,
            an identification number, location data, an online identifier, or to
            one or more factors specific to the physical, physiological,
            genetic, mental, economic, cultural, or social identity of that
            natural person. PI is, in many ways, the same as Personally
            Identifiable Information (PII). However, PI is broader in scope and
            covers more data. Your Rights Contact us using the information in
            the Data Access Request Submission section in this privacy notice to
            exercise any of your legal rights contained within this privacy
            notice. We will respond to your request within the legally mandated
            time of receiving it. Occasionally it may take longer for multiple
            requests or complex circumstances. When using our Website and
            submitting PI to us, you have certain rights under privacy laws in
            the United States, including the California Consumer Privacy Act
            (CCPA), the California Privacy Rights Act (CPRA), and privacy laws
            of other countries including the European Union General Data
            Protection Regulation (the EU GDPR), the UK General Data Protection
            Regulation (the UK GDPR), the UK Data Protection Act of 2018,
            Canada’s Personal UTA Website Privacy Notice Page 4 of 13
            Information Protection and Electronic Documents Act (PIPEDA), and
            other global privacy laws. Even if not listed here, we will make
            reasonable efforts to honor data subject access requests even though
            we may be under no legal obligation to do so. However, we reserve
            the right to decline any data subject access request that we are not
            legally obligated to comply with. Your rights include but are not
            limited to the following: 1. The right to one or more means you can
            submit requests under this privacy notice, including (at minimum) a
            toll-free telephone number and an email address if the business
            operates a storefront and a website. If the company operates only an
            Internet website, it must have a dedicated email address where you
            can submit requests for information required to be disclosed by law.
            2. The right to know whether your PI is sold or disclosed and to
            whom. 3. The right to request that we do not sell any of your PI. 4.
            The right to be informed about the PI we collect from you and how we
            process them. 5. The right to get confirmation that your PI is being
            processed and how you can access your PI. 6. The right to correct
            your PI if inaccurate or incomplete. 7. The right to request the
            removal or deletion of your PI if there is no compelling reason for
            us to continue processing them. However, the right to deletion is
            not absolute. It can be overridden to continue data processing in
            some cases where we still have a legal ground or overriding
            legitimate interest to process your data. 8. The right to ‘block’ or
            restrict the processing of your PI. When your PI is restricted, we
            are permitted to store your PI but not to process them further. 9.
            The right to request the PI you provided and use them for your
            purposes. Upon express request, we will provide your data to you or
            another service or product provider within 30 days of your request,
            subject to commercial and industrial secrets. 10. The right to
            object to us processing your PI for the following reasons: a.
            Processing was based on legitimate interests or the performance of a
            task in the public interest/exercise of official authority
            (including profiling). b. Direct marketing and targeted advertising
            (including profiling). c. Processing for purposes of
            scientific/historical research and statistics 11. The right that we
            limit the collection of your PI to that which is “adequate, relevant
            and reasonably necessary” with the purposes for which the data is
            processed. 12. The right to file a complaint with supervisory
            authorities if your information has not been processed in compliance
            with your rights under privacy laws. Please see further details in
            the last section HOW TO COMPLAIN. Information We Collect and How We
            Collect It Generally, you control the amount and type of information
            that you provide to us when using our Website. We collect several
            types of information from and about users of our Website, including
            information: <br />
            <br /> <br />• By which you may be personally identified, such as
            name, postal address, e-mail address, telephone number, or any other
            identifier by which you may be contacted online or offline
            (“personal information”). <br />
            <br /> <br />• That is about you but individually does not identify
            you, such as organization, company, or comments you may provide;
            and/or <br />
            <br /> <br />• About your internet connection, the equipment you use
            to access our website and usage details. We collect this
            information: <br />
            <br /> <br />• Directly from you when you provide it to us. <br />
            <br /> <br />• Automatically as you navigate through the site.
            Information collected automatically may include usage details, IP
            addresses, and information collected through cookies, web beacons,
            and other tracking technologies. <br />
            <br /> <br />• From third parties, for example, our business
            partners. Automatic Information We automatically receive information
            from your web browser or mobile device. This information may include
            the IP address of your computer or the proxy server you use to
            access the Internet, your Internet service provider’s name, your web
            browser type, the type of mobile device, your computer operating
            system, and data about your browsing activity when using our
            Website. We use all this information to help improve our Website.
            When Entering and Using Our Website When you enter and use our
            Website and agree to accept cookies, some cookies may contain your
            PI. Our Use of Cookies Our Website uses cookies. A cookie is a small
            piece of data, or a text file downloaded to your computer or mobile
            device when you access certain websites. Cookies may contain text
            that can be read by the web server that delivered the cookie to you.
            The text in the cookie consists of a sequence of letters and numbers
            that uniquely identifies your computer or mobile device; it may also
            contain other information. By agreeing to accept our use of cookies,
            you are giving us and the third parties with whom we partner
            permission to place, store, and access some or all the cookies
            described below on your computer and mobile device. <br /> <br />
            <br />• Strictly Necessary Cookies - These cookies are necessary for
            the website’s proper functioning, such as displaying content,
            logging in, confirming your session, responding to your request for
            services, and other functions. <br />
            <br /> <br />• Performance Cookies - These cookies collect
            information about the use of the website, such as pages visited,
            traffic sources, users’ interests, content management, and other
            website measurements. <br />
            <br /> <br />• Functional Cookies - These cookies enable the website
            to remember users’ choices, such as their language, usernames, and
            other decisions while using the website. <br />
            <br /> <br />• Session Cookies - These cookies allow websites to
            link the actions of a user during a browser session. Session cookies
            also permit users to be recognized as they navigate a website so
            that any item or page changes are remembered from page to page.
            Session cookies expire after a browser session. <br />
            <br /> <br />• Persistent Cookies - These cookies are stored on a
            user’s device between browser sessions, which allows the user’s
            preferences or actions across a website or different websites to be
            remembered. Persistent cookies may be used to remember users’
            choices and preferences when using a website or target advertising.{" "}
            <br />
            <br /> <br />• We may also use cookies for the following:
            –Identifying the areas of our Website that you have visited
            –Personalizing the content that you see on our Website –Our Website
            analytics –Remembering your preferences, settings, and log-in
            details –Speed up your searches Most web browsers can be set to
            disable the use of cookies. However, if you disable cookies, you may
            not be able to access features on our Website correctly, or at all.
            Web Beacons Pages of the Website and our e-mails may contain small
            electronic files known as web beacons (also referred to as clear
            gifs, pixel tags, and single-pixel gifs) that permit Company, for
            example, to count users who have visited those pages or opened an
            email and for other related website statistics (for example,
            recording the popularity of certain website content and verifying
            system and server integrity). Chat Software or Contact Forms Our
            Website may contain chat software or contact forms that enable
            visitors to communicate with us online or offline by email. When you
            use our chat software or contact forms, we may collect some or all
            the following information: your email address, first name, last
            name, location, and any other information you willingly choose to
            give us. How Your PI is Used We use the information we receive from
            you to: <br />
            <br /> <br />• To present our Website and its contents to you.{" "}
            <br />
            <br /> <br />• To provide you with information, products, or
            services that you request from us. <br />
            <br /> <br />• To fulfill any other purpose for which you provide
            it. <br />
            <br /> <br />• To carry out our obligations and enforce our rights
            arising from any contracts entered between you and us, including for
            billing and collection. <br />
            <br /> <br />• To notify you about changes to our Website or any
            products or services we offer or provide though it. <br />
            <br /> <br />• In any other way we may describe when you provide the
            information. <br />
            <br /> <br />• For any other purpose to fulfill our legitimate
            interests or with your consent. Communications and Emails When we
            communicate with you about our Website, we will use the email
            address you provided when registering as a user, We may also send
            you emails with promotional information about our Website or offers
            from us unless you have opted out of receiving such information. You
            can change your contact preferences at any time through your account
            or by contacting us using the information at the top of this privacy
            notice. Disclosing Your Data to Third Parties We do not sell or rent
            your PI to third parties for marketing purposes. However, for data
            aggregation purposes, we may use your NPI, which might be sold to
            other parties at our discretion. Any such data aggregation would not
            contain any of your PI. We do not control third parties’ collection
            or use of your information to serve interest-based advertising.
            However, these third parties may provide you with ways to choose not
            to have your information collected or used in this way. You can opt
            out of receiving targeted ads from members of the Network
            Advertising Initiative (“NAI”) on the NAI’s website: https://www.
            networkadvertising.org/. Disclosing Your PI to Service Providers and
            or Contractors Sometimes we give your PI to service providers and or
            contractors we hire to provide services to us. These service
            providers and contractors may include but are not limited to payment
            processors, data management services, help desk providers,
            accountants, law firms, state and federal courts, auditors, and
            email service providers. Legally Required Releases of Information We
            may disclose your PI if such disclosure is: 1. Required by subpoena,
            law, or other legal processes 2. Necessary to assist law enforcement
            officials or government enforcement agencies 3. Necessary to protect
            us from legal action or claims from third parties, including you 4.
            Necessary to protect the legal rights, personal and real property,
            or the personal safety of our company, users, employees, and
            business partners Disclosures to Successors If our business is sold
            or merges in whole or in part with another business that would
            become responsible for providing the website to you, we retain the
            right to transfer your PI to the new business. The new company would
            have the right to use your PI according to the terms of this privacy
            notice and any changes to this privacy notice as instituted by the
            new business. Data Retention Policy We retain your PI if it is
            necessary to provide our services and products to you and fulfill
            the purposes outlined in our privacy notice, subject to any legal
            obligations that may require a longer retention period. PI
            associated with your data will be kept until it is no longer
            necessary to provide our services and/or products or you ask us to
            delete them [subject to any legal obligations that may require a
            longer retention period]. The criteria used to determine our
            retention periods include: <br />
            <br /> <br />• The length of time we have a continuing relationship
            with you and provide the services and products you requested <br />
            <br /> <br />• Whether there is a legal obligation to which we are
            subject (for example, specific laws require us to keep records of
            your transactions for a certain period before we can delete them){" "}
            <br />
            <br /> <br />• Whether retention is advisable considering our legal
            position (such as for statutes of limitations, litigation, or
            regulatory investigations) PI about you that is no longer necessary
            to provide our products or services may be deidentified and
            aggregated with other NPI to provide insights, such as statistics on
            the use of our services and/or products. This information will be
            de-identified from your name and additional personally identifiable
            information. Do Not Track Settings Some web browsers have settings
            that enable you to request that our Website not track your movement
            within our Website. Our Website does not obey such settings when
            transmitted to and detected by our Website. You can turn off your
            browser’s tracking features and other security settings by referring
            to your browser’s user manual. Protecting Children’s Privacy Our
            Website is not intended for nor targeted towards children as defined
            by applicable law. We do not knowingly collect PI from minors under
            the age of 13. If you are a parent or guardian and believe that your
            child is providing PI to us via our Website, please get in touch
            with us at privacy@helvieta.com. Before we remove any information,
            we may ask for proof of identification to prevent malicious removal
            of account information. If we discover that a minor under the age of
            13 is providing access to us via our Website, we will delete their
            information within a reasonable period. Our Email Policy You can
            always opt out of receiving email correspondence from us or our
            affiliates. However, we will not sell, rent, or trade your email
            address to any unaffiliated third party without your permission
            except in the sale or transfer of our company or if our company
            files for bankruptcy as described in the section Disclosures to
            Successors. Our Security Policy We use commercially reasonable
            measures to secure information collected through the Website.
            Unfortunately, the transmission of information via the internet is
            not completely secure. Although we do our best to protect your
            personal information, we cannot guarantee the security of your
            personal information transmitted to our Website. Any transmission of
            personal information is at your own risk. We are not responsible for
            circumvention of any privacy settings or security measures contained
            on the Website. We restrict access to PI to our employees,
            contractors and agents who need to know that information to
            transmit, store or process it, who are subject to contractual
            confidentiality obligations consistent with this privacy policy, and
            who may be disciplined or terminated if they fail to meet these
            obligations. If any information in our possession or under our
            control is compromised because of a security breach, we will take
            reasonable steps to investigate the situation and, where
            appropriate, notify those individuals whose information may have
            been compromised and take other steps in accordance with applicable
            laws or regulations. Transferring PI From Other Countries PI that we
            collect from you may be stored, processed, and transferred among any
            countries in which we operate. The European Union has yet to find
            the United States and some other countries to have an acceptable
            level of protection of PI under Article 45 of the GDPR. Our company
            relies on derogations for specific situations defined in Article 49
            of the GDPR. If you are a European Union user or a user from another
            country, the company transfers personal information across
            international borders only: with your consent; to perform a contract
            with you; or to establish, exercise, or defend legal claims.
            Individuals in the EU may request a copy of applicable Article 46
            agreements by emailing privacy@helvieta. com Your California Privacy
            Rights California Civil Code Section § 1798.83 permits users of our
            Website that are California residents to request certain information
            regarding our disclosure of personal information to third parties
            for their direct marketing purposes. To make such a request, please
            follow the instructions in the Data Access Request Submission
            section of this notice. The following disclosures are made pursuant
            to the California Consumer Privacy Act of 2018 (“CCPA”) and identify
            the categories of personal information we have collected from
            California consumers on our Website over the past twelve months, the
            categories of sources from which the information was collected, the
            business or commercial purpose for which the information was
            collected, and the categories of third parties with whom we shared
            that information are described below. Categories of Personal
            Information Collected The following chart reflects the categories of
            personal information we have collected from California residents
            during the past twelve months, the categories of sources from which
            the information was collected, the business or commercial purpose
            for which the information was collected, the categories of third
            parties to whom we disclosed that information, and our anticipated
            retention period for each category of information. Privacy Policy
            1Privacy Policy 2Privacy Policy 3 Sources of Collection <br />
            <br /> <br />• You. <br /> <br /> <br />• Any other individual you
            have authorized to provide us with your personal information. <br />
            <br /> <br />• Devices you use to access our Website.
            Business/Commercial Purpose for Collection <br />
            <br /> <br />• To communicate with you. <br />
            <br /> <br />• To provide you with information or services that you
            request from us. <br />
            <br /> <br />• To improve our Website and present its contents to
            you. <br />
            <br /> <br />• To prevent, detect, and investigate fraud or other
            security incidents. Categories of Third Parties Receiving Personal
            Information <br />
            <br /> <br />• Affiliates <br />
            <br /> <br />• Technology services <br />
            <br /> <br />• Website analytics providers In the past twelve
            months, we have disclosed personal information collected through our
            Website for business or commercial purposes to our affiliate’s
            technology service providers and web analytics providers. The
            categories of personal information we have disclosed to third
            parties for business or commercial purposes are: Personal
            identifiers, including name, alias, and email address, internet
            activity information, including online identifiers such as Internet
            Protocol address or device identifier. In the past twelve months, we
            have not sold personal information to third parties. California
            residents have the right to opt out of the sale of their personal
            information. Because we do not sell personal information, we do not
            offer an opt out. Right to Know California residents have the right
            to request that we disclose the categories and specific pieces of
            personal information we collected, used, and disclosed during the
            past twelve months, the categories of sources from which their
            personal information was collected, our business or commercial
            purposes for collecting their personal information, and the
            categories of third parties with whom we shared their personal
            information. Right to Delete California residents have the right to
            request deletion of the personal information we have collected from
            them. Data Access Request Submission Should you wish to exercise
            your Data Privacy rights you or your authorized agent can submit a
            request by calling 1-(877) 678-1770 or by submitting your U.S
            request here, or your UK/EU based request here. You will need to
            provide us with personal information for us to match with
            information we have on file to verify your identity and residency.
            The personal information that we use to verify your identity and
            residency will not be used for any other purpose. Right Against
            Discrimination California residents have the right to not be
            discriminated against for exercising their rights under the CCPA. We
            do not discriminate against California residents who exercise their
            CCPA privacy rights. Data Security We use commercially reasonable
            measures to secure information collected through the Website.
            Unfortunately, the transmission of information via the internet is
            not completely secure. Although we do our best to protect your
            personal information, we cannot guarantee the security of your
            personal information transmitted to our Website. Any transmission of
            personal information is at your own risk. We are not responsible for
            circumvention of any privacy settings or security measures contained
            on the Website. We retain your information for as long as needed:
            (i) to conduct business with you; (ii) as needed for the purposes
            outlined in this Privacy Policy; (iii) as necessary to comply with
            our legal obligations, resolve disputes, and enforce any agreements.
            Changes to Our Privacy Notice We reserve the right to change this
            privacy notice at any time. If we make material changes to how we
            treat our users’ personal information, we will notify you in
            accordance with applicable law. The date the privacy policy was last
            revised is identified at the top of this page. You are responsible
            for periodically visiting our Website and this privacy policy to
            check for any changes. Your continued use of our services
            constitutes your acceptance of any amendment of this privacy policy.
            If following rejection of the changes, we will still hold your
            Personal Information on file, to adhere to applicable law. How to
            Complain If you have any concerns about our use of your personal
            information, you can make a complaint to us at Helvieta, LLC. 9608
            Wilshire Blvd, Beverly Hills, CA 90210, CA 90270 1-(827) 670-1510
            Privacy@helvieta.com UK – GDPR You can also complain to the ICO if
            you are unhappy with how we have used your data. ICO Information
            Commissioner’s Office Wycliffe House Water Lane, Wilmslow, Cheshire
            SK9 5AF Helpline: 0303 123 1113 www.ico.org.uk US - CCPA If you
            believe we have violated the CCPA, you may file a complaint with the
            Office of the Attorney General. Office of the Attorney General
            California Department of Justice P.O. Box 944255 Sacramento, CA
            94244-2550 Helpline: 916.210.6276 or (Toll-free in California)
            800.952.5225 Fax: 916.323.5341 www.oag.ca.gov Last Updated: February
            18, 2025
          </Typography>
        </Grid>
      </Box>
    </Box>
  );
}

const bodyStyle = {
  fontFamily: "Inter",
  fontSize: "0.95rem",
  lineHeight: 1.7,
  color: "#444",
};
